module.exports = __webpack_public_path__ + "img/chat-gpt-integration-cover.2c1d20e7.jpeg";